const AppName = 'Toolbox'

export default AppName